import { useState, useEffect } from 'react'

/**
 * Hook para detetar breakpoints responsivos.
 * @param query - Media query string (ex: "(min-width: 1024px)" para lg)
 * @returns true se a query corresponde
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    setMatches(mediaQuery.matches)

    const listener = (e: MediaQueryListEvent) => setMatches(e.matches)
    mediaQuery.addEventListener('change', listener)
    return () => mediaQuery.removeEventListener('change', listener)
  }, [query])

  return matches
}

/** lg breakpoint (1024px) - desktop: sidebar lateral; mobile/tablet: top bar */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)')
}

/** Orientação vertical (portrait) vs horizontal (landscape). Usado para disposições distintas. */
export function useIsPortrait(): boolean {
  return useMediaQuery('(orientation: portrait)')
}
